/**
 * Custom JavaScript to enable add to cart functionality on collection pages
 * regardless of layout type (horizontal or vertical)
 */

(function() {
  // Initialize add to cart functionality for collection page grid items
  function initCollectionAddToCart() {
    // Wait until the theme's AjaxProduct is available
    if (typeof theme === 'undefined' || typeof theme.AjaxProduct === 'undefined') {
      setTimeout(initCollectionAddToCart, 100);
      return;
    }

    // Find all grid items on collection pages
    var gridItems = document.querySelectorAll('.grid-product');
    
    gridItems.forEach(function(item) {
      // Make sure this is a collection page grid item
      if (item.closest('#CollectionAjaxContent')) {
        var productId = item.getAttribute('data-product-id');
        var productHandle = item.getAttribute('data-product-handle');
        
        if (productId && productHandle) {
          // First check if a form already exists (to avoid duplicates)
          var existingForm = item.querySelector('.product-single__form');
          
          if (!existingForm) {
            // If we're on a collection page and no form exists, fetch the product JSON and create one
            fetch('/products/' + productHandle + '.js')
              .then(function(response) { return response.json(); })
              .then(function(product) {
                createProductForm(item, product);
              })
              .catch(function(error) {
                console.error('Error fetching product data:', error);
              });
          } else {
            // Form already exists, just initialize it
            new theme.AjaxProduct(existingForm);
          }
        }
      }
    });
  }

  // Create a product form for a grid item
  function createProductForm(gridItem, product) {
    var content = gridItem.querySelector('.grid-product__content');
    if (!content) return;

    // Create the form element
    var form = document.createElement('form');
    form.method = 'post';
    form.action = '/cart/add';
    form.id = 'quick-add-' + product.id;
    form.className = 'product-single__form';
    form.setAttribute('enctype', 'multipart/form-data');

    // Add necessary hidden inputs
    form.innerHTML = `
      <input type="hidden" name="form_type" value="product">
      <input type="hidden" name="utf8" value="✓">
      <input type="hidden" name="id" value="${product.variants[0].id}">
      <button 
        type="submit" 
        name="add" 
        data-add-to-cart 
        class="btn btn--full add-to-cart">
        <span data-add-to-cart-text data-default-text="Add to cart">
          Add to cart
        </span>
      </button>
    `;

    // Append the form to the grid item content
    content.appendChild(form);

    // Initialize the form with AjaxProduct
    new theme.AjaxProduct(form);
  }

  // Run our initialization on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionAddToCart);
  } else {
    initCollectionAddToCart();
  }

  // Also run when the page content is updated via AJAX
  document.addEventListener('ajaxProduct:added', function() {
    setTimeout(initCollectionAddToCart, 500);
  });
})();
